import { IonApp, IonLoading, IonRouterOutlet, IonSplitPane } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { Redirect, Route, Switch } from "react-router-dom";
import Menu from "./components/Menu";
import Page from "./pages/Page";
import Login from "./pages/Login";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";
import * as auth from './auth/temp-auth';
/* Theme variables */
import "./theme/variables.css";
import styled from "styled-components";
import { format } from "path";
import React, { useEffect } from "react";
import { useAuth } from "./auth/authContext";
import DashboardPage from "./pages/Dashboard";
import UpcomingShedulePage from "./pages/upcoming-schedule";
import InspectionPage from "./pages/Inspections";
import ServiceProgramPage from "./pages/ServiceProgram";
import SiteSurveyPage from "./pages/SiteSurvey";
import PumpOutPage from "./pages/PumpOut";
import "./pages/Iframe.css"
import DrawCanvas from "./components/DrawingCanvas/DrawingCanvas";
import { Component } from "ionicons/dist/types/stencil-public-runtime";


const App: React.FC = () => {
  const { authInfo, initialize } = useAuth()!;

  useEffect(() => {
    !authInfo?.initialized && (async () => await initialize())();
  },[authInfo, initialize]);

  if (!authInfo || !authInfo.initialized) {
    return (
      <IonApp>
        <IonLoading isOpen={true} />
      </IonApp>
    );
  } else {
    return (
      <IonApp>
        <>
          {/* {authInfo?.loggedIn === true ? (
            <IonReactRouter>
              <IonSplitPane contentId="main">
                <Menu />
                <IonRouterOutlet id="main">
                  <Switch>
                  <Route path="/page/:name" component={Page} exact />
                  
                  <Route path="/" exact={true}>
              <Redirect to="/page/Inbox" />
            </Route>
                  </Switch>
                </IonRouterOutlet>
              </IonSplitPane>
            </IonReactRouter>
          ) : ( */}
            <IonReactRouter>
              
              <Route path="/login" component={Login} exact />
              <Route path="/dashboard" component={DashboardPage} exact />
              <Route path="/upcoming-schedule" component={UpcomingShedulePage} exact />
              <Route path="/inspection-page" component={InspectionPage} exact />
              <Route path="/service-program-page" component={ServiceProgramPage} exact />
              <Route path="/site-survey-page" component={SiteSurveyPage} exact />
              <Route path="/pump-out-page" component={PumpOutPage} exact />
              {/* <Route path="/accordion-page" component={AccordionPage} exact/> */}
              <Redirect from="/" to="/Login" exact />
            </IonReactRouter>
          
        </>
      </IonApp>
    );
  }
};



const InsPage = styled(IonApp)`
ion-alert{
  --max-width: unset !important;
  --width: 100% !important;
}

.alert-wrapper .sc-ion-alert-md-h{
  --max-width: unset !important;
  --width: 100% !important;

}

.alert-wrapper {
  width: 100% !important;
  max-width: 100% !important;
  }
`;





export default App;
